import * as angular from "angular";
import {IController, IScope} from "angular";
import {SupplyAccountType} from "../../types/supply-account.type";
import {$accountFactory} from "../../$account.factory";

export class SupplyAccountsTableRowCtrl implements IController {

  accountId: string;
  type: string;

  public supplyAccountsTypes: typeof SupplyAccountType = SupplyAccountType;

  constructor(private $account: $accountFactory, private $scope: IScope) {
  }

  $onInit() {
    if (this.accountId) {
      this.$account(this.accountId).$bindCtrlToId(this.$scope, this, 'account', 'accountId');
    }
  };

  $onChanges(changes) {
    if (changes.accountId && !changes.accountId.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountsTableRow', {
    bindings: {
      accountId: '<',
      type: '<'
    },
    template: require('./supply-accounts-table-row.html').default,
    controller: SupplyAccountsTableRowCtrl
  });
